import { Component, OnInit, Inject, Renderer2, ElementRef, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { SessaoService } from '../../services/sessao.service';
import { AbstractComponent } from '../../util/abstract.component';

declare var $: any;

@Component({
  selector: 'bra-alert',
  templateUrl: './bra-alert.component.html',
  styleUrls: ['./bra-alert.component.css']
})
export class BraAlertComponent extends AbstractComponent implements OnInit, OnDestroy {

  mensagem: string;
  erro: boolean;
  sucesso: boolean;
  eventListener: () => void;

  constructor(
    private sessaoService: SessaoService,
    public dialogRef: MatDialogRef<BraAlertComponent>,
    private router: Router,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    super(sessaoService);
  }

  ngOnInit() {
    this.mensagem = this.data.mensagem;
    this.erro = this.data.erro !== undefined ? this.data.erro : true;
    this.sucesso = this.data.sucesso !== undefined ? this.data.sucesso : false;
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    if (isMobile.matches) {
      $(".mat-dialog-container").css({"width":"80vw","left":"-30%"});
    }
    if (this.data.linkChat) {
      this.eventListener = this.renderer.listen(this.elementRef.nativeElement,
      'click', (event) => {
        if (event.target instanceof HTMLAnchorElement && event.target.href) {
          this.handleAnchorClick(event);
        }
      });
    }
  }

  fechar() {
    this.dialogRef.close();
    if (this.data.codigo === '1004') this.router.navigate(['/redefinirSenha', { cdPagina: 2 }]);
  }

   ngOnDestroy() {
     if (this.eventListener) this.eventListener();
  }

  handleAnchorClick(event: Event) {
    event.preventDefault();
    const anchor = event.target as HTMLAnchorElement;
    window.open(`${anchor.href}`,'popup','width=500,height=600');
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-alert/bra-alert.component.ts